(() => {
  "use strict";
  const s = (t) => window.productInfo.variants.find((e) => e.id === t),
    n = {},
    o = {
      thumbnailWrapper: "data-product-thumbnails",
      thumbnails: "data-thumbnail",
      mainImage: "data-main-image",
      video: "data-variant-video",
      variantButtons: "data-variant-button",
    },
    e = (e) => {
      e = s(e);
      const t = r(e);
      if (
        ((n.thumbnailWrapper.innerHTML = ""),
        t.forEach((e, t) => {
          if (!(5 < t)) {
            const i = document.createElement("button");
            i.setAttribute(o.thumbnails, t),
              (i.classList = "thumb"),
              0 === t && i.classList.add("is-active"),
              (i.innerHTML = `<img src="${d(e)}" alt="${
                e.image_alt_text
              }" aria-label="view product image ${t + 1}" />`),
              n.thumbnailWrapper.appendChild(i);
          }
        }),
        e.metafields.variant_youtube_video_id)
      ) {
        const i = document.createElement("button");
        i.setAttribute(o.thumbnails, "youtube"),
          (i.classList = "thumb thumb-play"),
          (i.innerHTML = `<img src="https://i3.ytimg.com/vi/${e.metafields.variant_youtube_video_id}/hqdefault.jpg" alt="product" aria-label="view product video" />`),
          n.thumbnailWrapper.appendChild(i);
      }
      a(), n.thumbnails[0].click();
    },
    r = (e) => e.metafields.variant_media || window.productInfo.media,
    d = (e) => e.variant_img_url || e.variant_image,
    t = (t) => {
      var e = "youtube" === t.target.getAttribute(o.thumbnails);
      const i = s(window.state.selectedVariant);
      if (
        (n.mainImage.classList.add("opacity-0"),
        n.thumbnails.forEach((e) => {
          e === t.target
            ? e.classList.add("is-active")
            : e.classList.remove("is-active");
        }),
        e)
      )
        setTimeout(() => {
          n.mainImage.classList.add("hidden"),
            (n.video.innerHTML = `<iframe width="560" height="315" class="max-w-full" src="https://www.youtube.com/embed/${i.metafields.variant_youtube_video_id}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`),
            n.video.classList.remove("hidden");
        }, 200);
      else {
        e = parseInt(t.target.getAttribute(o.thumbnails), 10);
        const a = r(i)[e];
        n.video.classList.add("hidden"),
          setTimeout(() => {
            n.mainImage.setAttribute("src", d(a)),
              n.mainImage.setAttribute("alt", a.image_alt_text),
              n.mainImage.classList.remove("opacity-0", "hidden"),
              n.mainImage.parentNode.setAttribute("href", a.variant_image),
              "undefined" != typeof refreshFsLightbox &&
                refreshFsLightbox &&
                refreshFsLightbox();
          }, 200);
      }
    },
    a = () => {
      (n.thumbnails = [...document.querySelectorAll(`[${o.thumbnails}]`)]),
        n.thumbnails.forEach((e) => {
          e.addEventListener("click", t);
        });
    },
    i = () => {
      (n.mainImage = document.querySelector(`[${o.mainImage}]`)),
        (n.thumbnailWrapper = document.querySelector(
          `[${o.thumbnailWrapper}]`
        )),
        (n.video = document.querySelector(`[${o.video}]`) || !1),
        (n.variantButtons = [
          ...document.querySelectorAll(`[${o.variantButtons}]`),
        ]),
        a(),
        window.listenToState((e) => {
          const t = s(e);
          n.variantButtons.forEach((e) => {
            e.getAttribute(o.variantButtons) === t.id.toString()
              ? e.classList.add("selected-variant")
              : e.classList.remove("selected-variant");
          });
        }, "selectedVariant");
    },
    l = {},
    c = {
      modal: "data-supplements-table",
      servingSize: "data-selected-serving-size",
      subModal: "data-subscriptions-modal",
    },
    u = (e, t) => {
      t
        ? (e.classList.add("right-0", "open"),
          e.classList.remove("-right-full"),
          document.body.classList.add("overflow-hidden"))
        : (e.classList.remove("right-0", "open"),
          e.classList.add("-right-full"),
          document.body.classList.remove("overflow-hidden"));
    },
    m = () => {
      (l.modal = document.querySelector(`[${c.modal}]`) || !1),
        (l.servingSize = document.querySelector(`[${c.servingSize}]`) || !1),
        (l.subModal = document.querySelector(`[${c.subModal}]`) || !1),
        window.listenToState((e) => {
          u(l.modal, e);
        }, "viewingFacts"),
        window.listenToState((e) => {
          u(l.subModal, e);
        }, "viewingSubscriptionFacts"),
        document.addEventListener("keydown", (e) => {
          (e.keyCode && 27 !== e.keyCode) ||
            (window.setState("viewingFacts", !1),
            window.setState("viewingSubscriptionFacts", !1));
        }),
        window.listenToState((e) => {
          e = s(e);
          l.servingSize.innerHTML = e.metafields.servings_per_container;
        }, "selectedVariant");
    },
    h = {},
    g = {
      imageTileOpeners: "data-image-text-opener",
      iconPlus: "data-icon-plus-circle",
      iconMinus: "data-icon-minus-circle",
    },
    v = () => {
      (h.imageTileOpeners = document.querySelectorAll(
        `[${g.imageTileOpeners}]`
      )),
        h.imageTileOpeners.forEach((e) => {
          e.addEventListener("click", function () {
            const e = this.nextSibling.nextElementSibling;
            this.classList.contains("mb-4")
              ? (this.classList.remove("mb-4"),
                e.classList.add("h-0"),
                e.classList.remove("h-auto"),
                this.querySelector(`[${g.iconPlus}]`).classList.remove(
                  "hidden"
                ),
                this.querySelector(`[${g.iconMinus}]`).classList.add("hidden"))
              : (this.classList.add("mb-4"),
                e.classList.add("h-auto"),
                e.classList.remove("h-0"),
                this.querySelector(`[${g.iconPlus}]`).classList.add("hidden"),
                this.querySelector(`[${g.iconMinus}]`).classList.remove(
                  "hidden"
                ));
          });
        });
    },
    p = {},
    b = {
      newsWidgets: "data-news-widget-group",
      newsDescriptions: "data-news-descriptions",
      newsDescriptionItem: "data-news-description",
      logo: "data-logo",
    },
    w = (e) => {
      var t = e.dataset.target;
      const i = e.closest("[data-news-widget-group]");
      let a = i.querySelectorAll(`[${b.newsDescriptionItem}]`),
        s = i.querySelectorAll(`[${b.logo}]`);
      s.forEach((e) => {
        e.classList.remove("active");
      }),
        a.forEach((e) => {
          e.classList.remove("active");
        }),
        e.classList.add("active"),
        document.getElementById(t).classList.add("active");
    },
    L = () => {
      p.newsWidgets.forEach((e) => {
        let t = 0,
          i = e.querySelectorAll(`[${b.newsDescriptionItem}]`);
        i.forEach((e) => {
          t = Math.max(t, e.offsetHeight || e.clientHeight);
        }),
          (e.querySelector(`[${b.newsDescriptions}]`).style.height = t + "px");
      });
    },
    f = () => {
      (p.newsWidgets = document.querySelectorAll(`[${b.newsWidgets}]`) || !1),
        0 < p.newsWidgets.length &&
          (p.newsWidgets.forEach((e) => {
            let t = e.querySelectorAll(`[${b.logo}]`);
            w(t[0]),
              t.forEach((e) => {
                e.addEventListener("click", function () {
                  w(this);
                }),
                  e.addEventListener("mouseover", function () {
                    w(this);
                  });
              });
          }),
          L(),
          window.addEventListener(
            "resize",
            function (e) {
              L();
            },
            !0
          ));
    };
  document.addEventListener("DOMContentLoaded", () => {
    i(), m(), v(), f();
  });
})();
